import axios from 'axios';
import { getMultisiteAccessListQuery } from './queries';

const getMultisiteAccessListDetails = () =>
    new Promise((resolve, reject) => {
        const query = getMultisiteAccessListQuery();
        const request = axios.get(query);

        request
            .then((response) => {
                resolve({ users: response.data });
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to process request'));
            });
    });

export default getMultisiteAccessListDetails;
